import { createApp } from "vue";
import { toPrix } from "./composant/b2bLangue";
import hash from "../hash";
import html from "./orderVerifie.html";
import Store from "../Store"; 
import { bootbox, B2bToast } from "../B2bTools";

function PrepareData(rows) {
    return rows.map(u => ({
        _id: u._id,
        order: `#${u.numeroErp}`,
        customer: u.clientK,
        door: u.door,
        ponumber: u.po,
        qt: u.totaux.qt,
        ht: u.totaux.ht,
        devise: u.devise,
        verifie: u.verifie.rows,
        messages: u.verifie.messages,
        isValidable: u.verifie.isValidable
    }));
}

const js = ({
    url: function (echangeur) {

        // let env =  Store.get("CTX").univer
         
        echangeur.addAction('b2b.orders.verifie', echangeur.hash, '', 'orders');
    },
    onLoad: function (echangeur) {

        // console.log(hash.toArray())

        let THIS = this;
        const form = echangeur.hash._ids
        const env =  Store.get("CTX").univer

        const datas = []
        for (let k of PrepareData(echangeur.orders.rows)) {
            if (form.split(',').find(u => (u == k._id))) datas.push(k)
        }

        let orders = echangeur.orders;
        
        let gotoOrderList = function () { 
            const esnv = hash.toArray()[0].par.u; 
            let url = esnv ? `#orderList&u=${esnv}` : "#universe";   
            if(orders && orders.rows && orders.rows.length>0 && orders.rows[0].ediBulk) url = esnv ? `#edi&u=${esnv}` : "#universe"; 
            window.location.href = url

        }

        console.log(datas)

        const app = createApp({
            data() {
                return {
                    datas,
                    ecran: echangeur.hash.ecran,
                    from: echangeur.hash.from,  // indique si on vient de orderList ou orderConfirm
                    message: ''
                }
            },
            computed: {
                error() {
                    let nb = 0
                    this.datas.forEach(function (u) { if (!u.isValidable) nb++ })
                    return { status: (nb > 0), number: nb }
                }
            },
            methods: {




                back() {
                    //console.log("back", this.ecran, this.un)
                    if (this.ecran === "delete") {
                        if (this.from) {
                            THIS.hashReplace("orderValidate", { _id: datas[0]._id });
                        } else {
                            // THIS.hashReplace("orderList",  { u:env });
                            
                            gotoOrderList()
                        }

                    } else {
                        hash.fin();
                    }

                },
                async confirm() {
                    const _ids = this.datas.filter(u => (u.isValidable)).map(u => u._id)
                    bootbox.confirm(
                        {
                            title: 'Confirm Order',
                            message: `You're about to confirm your order. <br>
                            This operation can not be cancelled, are you sure to continue ?`
                        },
                        async function () {
                            const result = await THIS.rest("b2b.orders.confirm", { _ids })
                            if (result.ok) {
                                //THIS.fin()
                                // THIS.hashReplace("orderList",  { u:env });
                                gotoOrderList()
                                //B2bToast("Order confirm", 'success', 3000)
                                B2bToast('Order has been confirmed', 'success')
                            }
                        })
                },
                async validate() {
                    const _ids = this.datas.filter(u => (u.isValidable)).map(u => u._id)
                    bootbox.confirm(
                        {
                            title: 'Validate Order',
                            message: `You're about to validate your order. <br>
                            This operation can not be cancelled, are you sure to continue ? <br>
                            <span class="text-danger">By validating this order, you expressly agree to CL International SA Terms and Conditions of Sale (available on your purchase order in PDF format).</span>`
                        },
                        async function () {
                            const result = await THIS.rest("b2b.orders.validate", { _ids })
                            if (result.ok) {
                                 //THIS.fin()
                                // THIS.hashReplace("orderList",  { u:env });
                                gotoOrderList()

                                //B2bToast("Order validate", 'success', 3000)
                                B2bToast('Order has been validated', 'success')
                            }
                        })
                },
                async remove() {
                    const _ids = this.datas.filter(u => (u.isValidable)).map(u => u._id);
                    const result = await THIS.rest("b2b.orders.delete", { _ids,env:env, message: this.message });

                    if (result.ok){
                            // THIS.hashReplace("orderList");

                            // hash.lance("orderList", {
                            //     u: env,
                            // });

                            gotoOrderList()

                    }
                },
                toPrix(value, devise) {
                    return toPrix(value, devise);
                },
            },
        });
        app.mount(THIS.c$('._vueChargement')[0]);
    }, 
});

export default {
    orderVerifie: { js: js, html: html }
};
